import { Image, Tooltip } from "@chakra-ui/react";
import { ImageProps } from "@chakra-ui/image/dist/types/image";

import { useContextConsumer } from "modules/context/Providers/ContextProvider";

interface IProps extends ImageProps {
  logoUrl: string;
}

const CustomLogoImage = ({ logoUrl, ...restProps }: IProps) => {
  const { logoMainDescription } = useContextConsumer();
  const logoDescription = logoMainDescription || "E-Rezerwacja";
  return (
    <Tooltip label={logoDescription} aria-label={logoDescription}>
      <Image
        alt={logoDescription}
        cursor="pointer"
        w="auto"
        maxH="70px"
        maxW="120px"
        src={logoUrl}
        {...restProps}
      />
    </Tooltip>
  );
};

export { CustomLogoImage };
